import type { DashboardOverview } from "@/api/db/dashboard";
import { DashboardLabels } from "@/lib/labels";
import {
	DashboardCard,
	DashboardCardBody,
	DashboardCardHeader,
	DashboardCardTitle,
} from "./dashboard-card";

function barTone(pct: number) {
	if (pct >= 80) {
		return "bg-primary";
	}
	if (pct >= 50) {
		return "bg-info";
	}
	if (pct >= 25) {
		return "bg-warning";
	}

	return "bg-destructive";
}

export function CompletenessPanel({
	completeness,
}: {
	completeness: DashboardOverview["completeness"];
}) {
	const base = Math.max(1, completeness.base);

	return (
		<DashboardCard data-component="dashboard-completeness">
			<DashboardCardHeader>
				<DashboardCardTitle>{DashboardLabels.charts.completeness}</DashboardCardTitle>

				<span className="font-mono text-xs text-muted-foreground">base {completeness.base}</span>
			</DashboardCardHeader>

			<DashboardCardBody className="grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2">
				{completeness.fields.map((field) => {
					const pct = Math.round((field.filled / base) * 100);

					return (
						<div
							key={field.field}
							data-component="completeness-row"
							data-field={field.field}
							data-filled={field.filled}
							data-pct={pct}
							className="min-w-0"
						>
							<div className="flex items-baseline justify-between gap-2">
								<span className="truncate text-sm text-foreground">
									{DashboardLabels.field(field.field)}
								</span>
								<span className="flex shrink-0 items-baseline gap-2 font-mono text-xs text-muted-foreground">
									<span>{field.filled}</span>
									<span className="text-muted-foreground">{pct}%</span>
								</span>
							</div>

							<div className="mt-1 h-2 overflow-hidden rounded-full bg-border">
								<div
									className={`h-full rounded-full ${barTone(pct)}`}
									style={{ width: `${pct}%` }}
								/>
							</div>
						</div>
					);
				})}
			</DashboardCardBody>
		</DashboardCard>
	);
}
